import railyApiService from "../raily-api.service";
import GpsCargoOrderRecordsRequest from "./cargo-order-records/gps-cargo-order-records-request";
import GpsCargoOrderRecordsResponse from "./cargo-order-records/gps-cargo-order-records-response";
import GpsPlanEntryRecordsRequest from "./plan-entry-records/gps-plan-entry-records-request";
import GpsPlanEntryRecordsResponse from "./plan-entry-records/gps-plan-entry-records-response";

const gpsApiService = () => {
  const getCargoOrderRecords = (
    request: GpsCargoOrderRecordsRequest,
    abortSignal: AbortSignal,
  ): Promise<GpsCargoOrderRecordsResponse> => {
    const url = `/gps-gateway/records/cargo-order/${request.orderUuid}/gps-time-nodes`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getPlanEntryRecords = (
    request: GpsPlanEntryRecordsRequest,
    abortSignal: AbortSignal,
  ): Promise<GpsPlanEntryRecordsResponse> => {
    const url = `/gps-gateway/records/plan-entry/${request.planEntryId}/gps-time-nodes`;

    return railyApiService().get<GpsPlanEntryRecordsResponse>({
      url,
      abortSignal,
    });
  };

  return {
    getCargoOrderRecords,
    getPlanEntryRecords,
  };
};

export default gpsApiService;
